import { defineMessages } from 'react-intl';

export default defineMessages({
    pupQuoteTitle: {
        id: 'wmic-pe-capability-gateway-quoteandbind-pup-react.pages.WMICPUPQuotePage.WMICPUPQuote.Title',
        defaultMessage: 'Quote',
    },
});
